const rateArr = [
  { id: 1, rate: 5, name: 1 },
  { id: 2, rate: 4, name: 2 },
  { id: 3, rate: 3, name: 3 },
  { id: 4, rate: 2, name: 4 },
  { id: 5, rate: 1, name: 5 }
];

export default rateArr;
